export default "__VITE_ASSET__B0gWzOrC__$_?url__"